import Vue from 'vue'
import Vant from 'vant'
import App from './App.vue'
import utils from './utils/utils'
import router from './router/router'
import 'vant/lib/index.css'
import { Table, TableColumn, ButtonGroup, Button } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@vant/touch-emulator';

Vue.prototype.$utils = utils

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(ButtonGroup)
Vue.use(Button)

// Vue.prototype.$tableScroll = (table) => {
//   table.$refs.body.scrollTop = 0;
//   table.$refs.body.scrollLeft = 0;
// }

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
